import type { QueryClient } from "@tanstack/react-query"
import type { TFunction } from "i18next"
import { revertFlashcardCorrection } from "@/lib/live/flashcard-capture"
import { askKeepSpelling, invalidateAfterCapture } from "@/lib/vocabulary-entries"

// "Keep my spelling" from the chat (#825 phase 3) — the toast on a corrected
// completion and the saved-word card both land here, so a refusal reads the
// same either way. The asking and the reading are askKeepSpelling's, shared
// with the strip and Browse (every refusal through revertErrorKey, which owns
// all four codes including rate_limited, and no toast when it is accepted);
// what belongs to the chat is the sentence for a request that never arrived —
// silence would let the student think the word was restored while the card
// keeps the corrected spelling — and the invalidation, which this transport
// does not do for itself.
//
// Returns whether the server accepted, because the two callers say so
// differently and only one of them is still on screen afterwards: the toast is
// dismissed by its own action, so it announces the restoring line as a second
// toast, while the card keeps its button mounted and renames it — where a
// toast would read the same sentence twice (the ruling on the strip, Task 12).
export async function requestKeepSpelling(
  entryId: string,
  { t, qc }: { t: TFunction; qc: QueryClient },
): Promise<boolean> {
  const entry = await askKeepSpelling(() => revertFlashcardCorrection(entryId), {
    t,
    transportErrorKey: "chat.vocabularyPopup.revertFailedToast",
  })
  if (!entry) return false
  invalidateAfterCapture(qc)
  return true
}
